// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__c2Qst","loader":"style_loader__Sc32B"};